import './styles/quasar.sass'
import lang from 'quasar/lang/pt-BR.js'
import '@quasar/extras/roboto-font/roboto-font.css'
import '@quasar/extras/material-icons/material-icons.css'
import '@quasar/extras/material-icons-outlined/material-icons-outlined.css'
import Dialog from 'quasar/src/plugins/dialog/Dialog.js';import Notify from 'quasar/src/plugins/notify/Notify.js';import AppFullscreen from 'quasar/src/plugins/app-fullscreen/AppFullscreen.js';import Cookies from 'quasar/src/plugins/cookies/Cookies.js';import Loading from 'quasar/src/plugins/loading/Loading.js';import QSpinnerHourglass from 'quasar/src/components/spinner/QSpinnerHourglass.js';import BottomSheet from 'quasar/src/plugins/bottom-sheet/BottomSheet.js';;

Notify.registerType('positive', {
  icon: 'o_check_circle',
  progress: true,
  classes: 'app-notify app-notify-positive',
})
Notify.registerType('negative', {
  icon: 'o_error',
  progress: true,
  classes: 'app-notify app-notify-negative',
})
Notify.registerType('warning', {
  icon: 'o_warning',
  progress: true,
  classes: 'app-notify app-notify-warning',
})
Notify.registerType('info', {
  icon: 'o_info',
  progress: true,
  classes: 'app-notify app-notify-info',
})

export default {
    config: {
      loading: {
        message: 'Carregando, por favor aguarde...',
        spinner: QSpinnerHourglass,
      },
      notify: {
        position: 'top',
        timeout: 3000,
        classes: 'app-notify',
        progress: true,
      }
    },
    plugins: [Dialog, Notify, AppFullscreen, Cookies, Loading, BottomSheet],
    lang: lang
}